<template>
  <DialogBase
    title="Thêm học sinh vào nhóm"
    :visible.sync="dialogVisible"
    size="lg"
    :use-panel="false"
    confirm-text="Lưu"
    confirm-type="primary"
    :confirm-loading="loadingButton"
    cancel-text="Hủy"
    cancel-type=""
    cancel-icon=""
    confirm-icon=""
    @before-close="handleClose"
    @cancel="handleClose"
    @confirm="handleSave"
    @open="handleOpen"
  >
    <div class="sk-panel">
      <div class="sk-panel-head">
        <div class="sk-panel-icon">
          <i class="el-icon-s-operation" />
        </div>
        <div>
          <p class="sk-panel-title">Quản lý học sinh</p>
          <p class="sk-panel-subtitle">Thêm hoặc bỏ học sinh khỏi nhóm</p>
        </div>
      </div>

      <el-transfer
        v-loading="loadingDataTransfer"
        :element-loading-text="$tableLoading"
        filterable
        filter-placeholder="Nhập thông tin học sinh"
        v-model="dataTarget"
        :titles="['Tất cả học sinh', 'Học sinh trong nhóm']"
        :button-texts="['', '']"
        :data="dataSource"
      />
    </div>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import KidsGroupService from "@/services/KidsService/KidsGroupService";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { DialogBase },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingDataTransfer: false,
      dataSource: [],
      dataTarget: [],
      dataSubmit: {
        id: Number,
        idKidsGroupList: [],
      },
      loadingButton: false,
      checkUpdateTransfer: "",
      gradeOfSchoolList: [],
      classOfGradeList: [],
      searchCodeOrname: "",
    };
  },
  watch: {
    studentList: {
      handler() {
        if (this.studentList.length > 0) {
          setTimeout(() => {
            this.loadingDataTransfer = false;
          }, 1000);
        }
      },
    },
  },
  computed: {
    ...mapGetters("studentStore", ["studentList"]),
  },
  methods: {
    ...mapActions("studentStore", [
      "fetchDataStudentList",
      "fetchDataKidsGroupList",
    ]),

    handleOpen() {
      this.loadingDataTransfer = true;
      this.fetchDataStudentList();
    },

    handleClose(done) {
      this.$emit("dialog-close");
      this.$nextTick(() => {
        this.dataSource = [];
        this.dataTarget = [];
      });
      if (typeof done === "function") done();
    },

    handleSave() {
      this.dataSubmit.idKidsGroupList = this.dataTarget;
      this.loadingButton = true;
      KidsGroupService.updateTransferGroup(this.dataSubmit)
        .then((resp) => {
          this.fetchDataKidsGroupList();
          this.checkUpdateTransfer = resp.data.data;
          this.$message({
            message: "Chuyển học sinh trong nhóm thành công",
            type: "success",
          });
          this.handleClose();
          location.reload();
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: "error",
          });
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },

    /**
     * get student of group
     */
    async getGroupById(id) {
      await KidsGroupService.getById(id)
        .then((resp) => {
          this.dataTarget = resp.data.data.idKidsList;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * get data source
     */
    setDataSource() {
      const dataResponse = [];
      const states = this.studentList.filter(
        (kid) => kid.kidStatus === "Đang học"
      );
      states.forEach((kid) => {
        dataResponse.push({
          label:
            kid.fullName +
            " -- " +
            kid.maClass.className +
            " -- " +
            kid.kidStatus,
          key: kid.id,
        });
      });
      this.dataSource = dataResponse;
    },

    /**
     * get data initial
     */
    async getDataInitial(id) {
      await this.fetchDataStudentList();
      await this.getGroupById(id);
      this.setDataSource();
      this.dataSubmit.id = id;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";

/deep/ .el-transfer-panel__body {
  height: 300px;
}

/deep/ .el-transfer-panel__list.is-filterable {
  height: 245px;
  padding-top: 0;
}

/deep/ .el-transfer-panel .el-transfer-panel__header {
  background: #2563eb;
}

/deep/ .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label span {
  color: white;
}

/deep/ .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
  color: white;
}

/deep/ .el-transfer-panel {
  width: 40%;
}
</style>
